import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../assets/css/_element.reset.scss'
Vue.use(Element)
